export const feetToMeter = (value: number) => value / 3.28084;
